import { Modal, Typography, Box, Button } from '@mui/material';
import { numberFormat } from 'helpers/i18n';
import { postRedemptionAttempt } from 'lib/api/rewards';
import { useEffect } from 'react';
import BitcoinBlue from 'assets/bitcoinRewardsSection/bitcoin-blue.png';
import LockIcon from 'assets/bitcoinRewardsSection/lock-icon.png';

const styles = {
    modalComponent: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '513px',
        backgroundColor: '#FFFFFF'
    },
    headerRedemption: {
        color: '#182C55',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '23px',
        lineHeight: '28px',
        textAlign: 'center'
    },
    subtitleRedemption: {
        fontStyle: 'normal',
        fontWeight: '500',
        fontSize: '14px',
        lineHeight: '22px',
        textAlign: 'center',
        color: '#617380',
        marginTop: '8px'
    },
    redemButton: {
        display: 'block',
        width: '180px',
        padding: '10px 32px',
        background: '#1BABE2',
        borderRadius: '4px',
        color: '#FFF',
        margin: '25px auto',
        '&:hover': {
            backgroundColor: 'rgba(27, 171, 226, 0.75)'
        }
    },
    blueBox: {
        margin: '56px auto 32px auto',
        width: '112px',
        height: '112px',
        background: 'rgba(27, 171, 226, 0.15)',
        padding: '24px',
        borderRadius: '4px',
        position: 'relative'
    }
};

export default function RedemptionComponent({ show, onClose, allowRedemption, toSpend, mimumRedemption }) {
    useEffect(() => {
        if (!show) return;
        if (allowRedemption) {
            postRedemptionAttempt().catch(error => {
                console.error(error);
            });
        }
    });

    const handleClose = (e, reason) => {
        onClose(reason);
    };

    const buttonClick = () => {
        handleClose(null, 'buttonClick');
    };

    return (
        <Modal open={show} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <Box sx={styles.modalComponent}>
                <Box sx={styles.blueBox}>
                    <Box
                        sx={{
                            display: 'block',
                            marginLeft: 'auto',
                            marginRight: 'auto'
                        }}
                        component="img"
                        alt="Bitcoin Reward"
                        src={BitcoinBlue}
                    />
                    {!allowRedemption && (
                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: '-25%',
                                right: '-25%'
                            }}
                            component="img"
                            alt="Lock icon Reward"
                            src={LockIcon}
                        />
                    )}
                </Box>
                <Box
                    sx={{
                        padding: '8px 62px'
                    }}>
                    <Typography sx={styles.headerRedemption} id="modal-modal-title" variant="h6" component="h2">
                        {allowRedemption
                            ? 'You are eligible for redemption!'
                            : `Unlock redemption by spending at least ${numberFormat(mimumRedemption, 0)} with DeFi Card`}
                    </Typography>
                    <Typography sx={styles.subtitleRedemption} id="modal-modal-description">
                        {allowRedemption
                            ? 'A member of our team will reach out to you shortly to help you with the redemption process.'
                            : `Spend ${numberFormat(toSpend, 0)} more to redeem your satoshi points`}
                    </Typography>
                    <Button sx={styles.redemButton} onClick={buttonClick}>
                        Ok
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
}
